enum FieldType {

    Amount = "amount",
    Currency = "currency",
    CardName = "cardName",
    CardNumber = "cardNumber",
    CardExpiration = "cardExpiration",
    CardCvv = "cardCvv",
    PromotionCode = "promotionCode",
    IDCard = "idCard",
}

namespace FieldType {
}

export {
    FieldType
};
